import * as types from '../actiontypes';
import {
	API_RESOURCES,
	createApiCreateAction,
	createApiReadAction,
	createApiUpdateAction,
	createApiDeleteAction
} from '../../util/api';
import {sampleTypes, entities} from '../../util/uiconstants';

export const createControlAttributes = (engagementId, payload) =>
	createApiCreateAction(
		types.CREATE_CONTROL_ATTRIBUTES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: null
		},
		payload
	);

export const updateControlAttributes = (engagementId, attributeId, payload) =>
	createApiUpdateAction(
		types.UPDATE_CONTROL_ATTRIBUTES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: attributeId
		},
		payload
	);

export const getControlAttributes = (engagementId, controlId, documentId) => {
	const queryString = {
		entityUIDINTs: controlId,
		entityId: entities.Control,
		sampleTypeId: sampleTypes.controlAttributeTesting,
		includePagination: false,
		documentId
	};

	return createApiReadAction(
		types.GET_CONTROL_ATTRIBUTES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: null
		},
		queryString
	);
};

export const deleteControlAttributes = (engagementId, attributeId, documentId) => {
	const queryString = {hostDocumentId: documentId};

	return createApiDeleteAction(
		types.DELETE_CONTROL_ATTRIBUTES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.CONTROL_ATTRIBUTES]: attributeId
		},
		{attributeId},
		true,
		undefined,
		queryString
	);
};
